import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorisation-error-page',
  templateUrl: './authorisation-error-page.component.html',
  styleUrls: ['./authorisation-error-page.component.scss']
})
export class AuthorisationErrorPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
